import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useTheme } from "../ThemeManager"; // Import the theme context
import "../css/Confetti.css"; // Import the new CSS file

const Confetti = ({ count = 50 }) => {
  const [particles, setParticles] = useState([]);
  const { currentTheme } = useTheme(); // Access the current theme
  
  useEffect(() => {
    // Define colors and shapes - these could also be theme-dependent
    const colors = ["yellow", "purple", "red", "blue", "green"];
    const shapes = ["■", "●", "★", "♦", "▲"];

    const newParticles = Array.from({ length: count }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: -20,
      rotation: Math.random() * 360,
      scale: 0.5 + Math.random() * 1,
      colorClass: `confetti-color-${colors[Math.floor(Math.random() * colors.length)]}`,
      shape: shapes[Math.floor(Math.random() * shapes.length)],
      delay: Math.random() * 2,
    }));

    setParticles(newParticles);
  }, [count]);

  return (
    <div className="confetti-container">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          initial={{
            x: `${particle.x}vw`,
            y: `${particle.y}vh`,
            scale: 0,
            rotate: 0,
          }}
          animate={{
            x: [
              `${particle.x}vw`,
              `${particle.x + (Math.random() * 20 - 10)}vw`,
              `${particle.x + (Math.random() * 40 - 20)}vw`,
            ],
            y: ["0vh", "100vh"],
            scale: [0, particle.scale, 0],
            rotate: [0, particle.rotation * 2],
          }}
          transition={{
            duration: 5 + Math.random() * 2,
            delay: particle.delay,
            ease: "easeOut",
            repeat: Infinity,
          }}
          className={`confetti-particle ${particle.colorClass}`}
        >
          {particle.shape}
        </motion.div>
      ))}
    </div>
  );
};

export default Confetti;